import React from 'react';
import { Drawer } from '@mui/material';
import NexusChat from './NexusChat';

export default function NexusChatDrawer({ open, onClose, getToken, context }) {
  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: { xs: '100%', sm: 640 },
          bgcolor: '#0a0a0a',
          p: 2,
          display: 'flex',
          flexDirection: 'column'
        }
      }}
    >
      {open && (
        <NexusChat
          getToken={getToken}
          initialContext={context}
          onClose={onClose}
        />
      )}
    </Drawer>
  );
}
